module.exports = __webpack_public_path__ + "img/ebook-google.eddf26a1.png";